"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var linear_gradient_1 = require("../linear-gradient");
var color_1 = require("../color");
var media_query_1 = require("../../../hooks/media-query");
var CtaButton = function (props) {
    // TODO: remove state for hover animation
    var _a = (0, hooks_1.useState)(false), hovered = _a[0], setHovered = _a[1];
    var isDesktop = (0, media_query_1.useMediaQuery)('(min-width: 1025px)');
    // Basic styling
    var styles = {
        style: {
            color: (0, color_1.toHex)(hovered ? props.hoverColor : props.textColor || 'white'),
            'background-image': (0, linear_gradient_1.linearGradient)(props.backgroundColor),
        },
    };
    // For hover effect on desktop
    var onFunctions = isDesktop
        ? {
            onMouseEnter: function () { return setHovered(true); },
            onMouseLeave: function () { return setHovered(false); },
        }
        : {};
    // Class name manipulation
    var classList = ['button--2', 'button--CtaButton'];
    if (typeof props.handleClick !== 'function') {
        classList.push('button--CtaHref');
    }
    if (props.size) {
        classList.push("button--CtaButton-".concat(props.size));
    }
    var classes = {
        className: classList.join(' '),
    };
    // Merge all properties for JSX
    var properties = __assign(__assign(__assign({}, styles), onFunctions), classes);
    return (
    // render button tag if cta has a function, a tag if cta has href
    (0, preact_1.h)(preact_1.Fragment, null, typeof props.handleClick === 'function' ? ((0, preact_1.h)("button", __assign({ onClick: props.handleClick }, properties), props.text)) : ((0, preact_1.h)("a", __assign({ href: props.scrollTo || '#anchor--product-title' }, properties), props.text))));
};
exports.default = CtaButton;
